import { Injectable } from '@angular/core';
import { AddLinkPayload } from '@core/utils/models/link.model';
import { HttpHandler } from '@shared/utils/classes/http-handler';
import { HttpResponse } from '@shared/utils/models/http.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class LinkService extends HttpHandler {
  addLinks(links: AddLinkPayload[]): Observable<HttpResponse<number>> {
    const url: string = environment.apiUrls.links.add;
    return this.post<HttpResponse<number>>(url, { ids: links.map((link) => JSON.stringify(link)) });
  }

  deleteLinks(linkIds: number[]): Observable<HttpResponse<number>> {
    const url: string = environment.apiUrls.links.delete;
    return this.post<HttpResponse<number>>(url, { ids: linkIds });
  }

  addSocialMediaLinks(links: AddLinkPayload[], deletedLinkIds: number[]): Observable<HttpResponse<number>> {
    const url: string = environment.apiUrls.links.socialMedia.add;
    return this.post<HttpResponse<number>>(url, {
      ids: links.map((link) => JSON.stringify(link)),
      deleted_ids: deletedLinkIds,
    });
  }

  deleteSocialMediaLinks(linkIds: number[]): Observable<HttpResponse<number>> {
    const url: string = environment.apiUrls.links.socialMedia.delete;
    return this.post<HttpResponse<number>>(url, { ids: linkIds });
  }
}
